import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { RootState } from '../stores';
import { getToken } from '../stores/slices/auth';
import { withReauth } from './base-query-with-reauth';

const baseQuery = fetchBaseQuery({
  baseUrl: '/api',
  prepareHeaders: (headers, { getState }) => {
    const state = getState() as RootState;
    const token = getToken(state)?.accessToken;

    if (token) {
      headers.set('Authorization', `Bearer ${token}`);
    }
  }
});

export const tms = createApi({
  reducerPath: 'tms',
  baseQuery: withReauth(baseQuery),
  tagTypes: [
    'Clinicians',
    'Clinics',
    'Internal',
    'LifeglovLinerOrder',
    'LifeglovLinerStock',
    'MetricTargets',
    'Patient',
    'PatientLifeglov',
    'PatientActivityLog',
    'PatientSessions',
    'Users',
    'Insights',
    'Profile',
    'Subtenants'
  ],
  endpoints: () => ({
    // As a general rule, no endpoints should be registered here
    // Instead, they should be registered in the `injectEndpoints` method in the
    // appropriate file in the `api` directory
  })
});
